import "./AttendanceDetails.css";
import { useState, useEffect } from "react";

// components
import Calendar from "../../../components/Calendar";
import CheckInOut from "./CheckInOut";
import Widgets from "../../../components/Widgets";
import WidgetsIcon from "../../../components/Widgets/icon";
import InfoCard from "../../../components/InfoCard";
import WidgetsButton from "../../../components/Widgets/button";
import { Col, Row } from "react-bootstrap";
import { FiPlus } from "react-icons/fi";
import { CiUser } from "react-icons/ci";
import {
  BsCalendarCheck,
  BsCalendarX,
  BsCalendarDate,
  BsClock,
  BsCalendar,
} from "react-icons/bs";

import { useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";

import { getAttendanceModulePath } from "../../../services/config";
import { getAttendModule, initAttModule } from "../../../redux/slices/moreSettings";

const AttendanceDetails = ({ user, userDetails, commonState }) => {
  const navigate = useNavigate();
  const dispatch = useDispatch();

  const attendanceStore = useSelector((state) => state.moreSettings);

  const [moduleList, setModuleList]       = useState([]);
  const [totalDays, setTotalDays]         = useState(0);
  const [presentDays, setPresentDays]     = useState(0);
  const [absentDays, setAbsentDays]       = useState(0);
  const [halfDays, setHalfDays]           = useState(0);
  const [averageWorkHrs, setAverageWorkHrs] = useState("0h 0m");

  /* ── fetch attendance module on mount ── */
  useEffect(() => {
    dispatch(getAttendModule(`${getAttendanceModulePath}${user.user_id}`));
  }, []);

  /* ── handle store response ── */
  useEffect(() => {
    if (attendanceStore.mSetGetAttModSuccess) {
      setModuleList(attendanceStore.mSetGetAttModData);
      dispatch(initAttModule());
    }
  }, [attendanceStore]);

  /* ── calendar data callback ── */
  const handleState = (data) => {
    setTotalDays(data.length);

    const present = data.filter((item) => item.statusCode == "1");
    setPresentDays(present.length);

    const absent = data.filter((item) => item.statusCode == "2");
    setAbsentDays(absent.length);

    const half = data.filter((item) => item.statusCode == "3");
    setHalfDays(half.length);

    // average work hours calculation
    const withHours = data.filter((item) => item.workHours > 0);
    if (withHours.length > 0) {
      const totalMins = withHours.reduce((acc, item) => acc + (item.workHours || 0), 0);
      const avgMins   = Math.round(totalMins / withHours.length);
      const hrs       = Math.floor(avgMins / 60);
      const mins      = avgMins % 60;
      setAverageWorkHrs(`${hrs}h ${mins}m`);
    } else {
      setAverageWorkHrs("0h 0m");
    }
  };

  const handleAttendaceSet = () => {
    localStorage.setItem("emp-redirect", window.location.pathname);
    navigate("/attendance-setting");
  };

  /* ── stat cards config ── */
const statCards = [
  { title: "Total Days",           value: `${totalDays} Days`,  icon: <BsCalendar /> },
  { title: "Present Days",         value: `${presentDays} Days`, icon: <BsCalendarCheck /> },
  { title: "Absent Days",          value: `${absentDays} Days`,  icon: <BsCalendarX /> },
  { title: "Half Days",            value: `${halfDays} Days`,    icon: <BsCalendarDate /> },
  { title: "Average Work Hours",   value: averageWorkHrs,        icon: <BsClock /> },
];

  return (
    <div style={{ padding: "0 10px" }}>
      <Row>
        {/* ── Stat Cards ── */}
        <Col sm={12} className="mb-3">
          <div className="info-card-wrapper">
            {statCards.map((card) => (
              <InfoCard
                key={card.title}
                title={card.title}
                value={card.value}
                icon={card.icon}
              />
            ))}
          </div>
        </Col>

        {/* ── Attendance Calendar ── */}
        <Col sm={12} className="mb-3">
          <Widgets
            icon={<WidgetsIcon icon={<CiUser />} title="Attendance Details" />}
            // button={
            //   <WidgetsButton
            //     type="button"
            //     text="Add Attendance"
            //     icon={<FiPlus className="btn-icon" />}
            //     onClick={handleAttendaceSet}
            //   />
            // }
            body={
              <Row className="mt-3">
                <Calendar
                  userId={user.user_id}
                  staffId={userDetails[0].staffId}
                  handleState={handleState}
                />
              </Row>
            }
          />
        </Col>
      </Row>
    </div>
  );
};

export default AttendanceDetails;